export { default as favicon } from "../assets/images/logo/favicon.webp";
export { default as mainLogo } from "../assets/images/logo/logo.webp";
export { default as flight_video_img } from "../assets/images/flight-video-img.avif";
export { default as plane_takeoff } from "../assets/images/plane-takeoff.svg";
export { default as plane_landing } from "../assets/images/plane-landing.svg";
export { default as calendar } from "../assets/images/calendar.svg";
export { default as profile_banner } from "../assets/images/Banner-1.webp";
export { default as Travelers_Class } from "../assets/images/travelers-class.svg";
export { default as manali } from "../assets/images/manali.avif";
export { default as holiday_mood } from "../assets/images/holiday-mood.webp";
export { default as Holiday_Banner } from "../assets/images/HolidayBanner.webp";
export { default as About_Us } from "../assets/images/about_us.webp";
export { default as What_We_Offer_background } from "../assets/images/What-We-Offer-background.png";
export { default as india_map_dot } from "../assets/images/India_map_dot.png";
export { default as indigo_side_banner } from "../assets/images/indigo-side-banner.jpg";
export { default as spicejet_side_banner } from "../assets/images/spicejet-side-banner.jpg";
export { default as who_we_are } from "../assets/images/who_we_are.webp";
export { default as offer_bg } from "../assets/images/offer-bg-a.avif";
export { default as offer_bg_2 } from "../assets/images/offer-bg-b.avif";
export { default as info_background } from "../assets/images/info-background.jpg";
export { default as no_data_found } from "../assets/images/no_data_found.webp";
export { default as Hotel_Loader } from "../assets/images/Hotel-Loader.gif";
export { default as flight_Loader } from "../assets/images/flightloader.gif";
export { default as flightLoader } from "../assets/images/flight-loader.gif";
export { default as img_Loader } from "../assets/images/loader.webp";
export { default as flightResultLoader } from "../assets/images/flightpage-loader.gif";


export { default as done } from "../assets/images/done.gif";
export { default as errorImg } from "../assets/images/error-img.gif";
export { default as WorldTravel } from "../assets/images/WorldTravel.png";
export { default as Chip } from "../assets/images/chip.webp";
export { default as CardLogo } from "../assets/images/card-logo.png";
export { default as CreditCardBG } from "../assets/images/credit-card_bg.webp";
export { default as loginBack } from "../assets/images/login-back.webp";
export { default as locationImg } from "../assets/images/location-img.webp";
export { default as hotel_offer } from "../assets/images/hotel-offer.webp";
export { default as instant_Hotel } from "../assets/images/offers/Hotel-offer.jpg";
export { default as Hotel_Holiday } from "../assets/images/offers/Hotel-Holiday.jpg";
export { default as flight_offer } from "../assets/images/offers/flight-offer.jpg";


export { default as FlightOffer } from "../assets/images/offers/Flight-offer.webp";
export { default as FlightOffer2 } from "../assets/images/offers/Flight-offer2.webp";
export { default as HotelOffer } from "../assets/images/offers/Hotel-offer.jpg";
export { default as indigoFlight } from "../assets/images/flights/indigo.jpg";


export { default as logo_holiday } from "../assets/images/logo/logo-holiday.webp";
export { default as logo_hotel } from "../assets/images/logo/logo-hotel.webp";
export { default as No_hotel } from "../assets/images/No-hotel-img.png";
export { default as no_images } from "../assets/images/holiday/images.jpg";


export { default as testimonial_video } from "../assets/images/testimonial_video.png";


export { default as gallery_1 } from "../assets/images/gallery/1.webp";
export { default as gallery_2 } from "../assets/images/gallery/2.webp";
export { default as gallery_3 } from "../assets/images/gallery/3.webp";
export { default as gallery_4 } from "../assets/images/gallery/4.webp";
export { default as gallery_5 } from "../assets/images/gallery/5.webp";
export { default as gallery_6 } from "../assets/images/gallery/6.webp";
export { default as gallery_7 } from "../assets/images/gallery/7.webp";
export { default as gallery_8 } from "../assets/images/gallery/8.webp";
export { default as gallery_9 } from "../assets/images/gallery/9.webp";
export { default as gallery_10 } from "../assets/images/gallery/10.webp";
export { default as gallery_11 } from "../assets/images/gallery/11.webp";
export { default as gallery_12 } from "../assets/images/gallery/12.webp";
export { default as gallery_13 } from "../assets/images/gallery/13.webp";
export { default as gallery_14 } from "../assets/images/gallery/14.webp";
export { default as gallery_15 } from "../assets/images/gallery/15.webp";
export { default as gallery_16 } from "../assets/images/gallery/16.webp";
export { default as gallery_17 } from "../assets/images/gallery/17.webp";
export { default as gallery_18 } from "../assets/images/gallery/18.webp";
export { default as gallery_19 } from "../assets/images/gallery/19.webp";
export { default as gallery_20 } from "../assets/images/gallery/20.webp";
export { default as gallery_21 } from "../assets/images/gallery/21.webp";
export { default as gallery_22 } from "../assets/images/gallery/22.webp";
export { default as gallery_23 } from "../assets/images/gallery/23.webp";
export { default as gallery_24 } from "../assets/images/gallery/24.webp";
export { default as gallery_25 } from "../assets/images/gallery/25.webp";
export { default as gallery_26 } from "../assets/images/gallery/26.webp";
export { default as gallery_27 } from "../assets/images/gallery/27.webp";
export { default as gallery_28 } from "../assets/images/gallery/28.webp";




export { default as Offer1 } from "../assets/images/discount/offer1.webp";
export { default as Offer2 } from "../assets/images/discount/offer2.webp";
export { default as Offer3 } from "../assets/images/discount/offer3.webp";
export { default as Offer4 } from "../assets/images/discount/offer4.webp";


export { default as Amarendra_Khatua } from "../assets/images/team/amarendra_khatua.jpg";
export { default as Bader_Uddin } from "../assets/images/team/bader_uddin.jpg";
export { default as Pratyush_Kumar } from "../assets/images/team/pratyush_kumar.jpg";
export { default as Shaquib_Raza } from "../assets/images/team/shaquib_raza.jpg";
export { default as ceo } from "../assets/images/team/ceo.jpg";


export { default as India } from "../assets/images/Locations/india.webp";
export { default as Dubai } from "../assets/images/Locations/Dubai.webp";
export { default as Singapore } from "../assets/images/Locations/Singapore.webp";
export { default as USA } from "../assets/images/Locations/USA.webp";
export { default as Location_img1 } from "../assets/images/Locations/Dubai.webp";
export { default as Location_img2 } from "../assets/images/Locations/india.webp";
export { default as Location_img3 } from "../assets/images/Locations/USA.webp";
export { default as Location_img4 } from "../assets/images/Locations/Singapore.webp";
export { default as Location_img5 } from "../assets/images/Locations/London.webp";
export { default as Location_img6 } from "../assets/images/Locations/Berlin.webp";


export { default as Explore_World } from "../assets/images/holiday/Explore-World.webp";
export { default as kolkata } from "../assets/images/holiday/kolkata.avif"
export { default as bangalore } from "../assets/images/holiday/bangalore.avif"
export { default as agra } from "../assets/images/holiday/agra.avif"
export { default as Delhi } from "../assets/images/holiday/Delhi.avif"
export { default as Goa } from "../assets/images/holiday/Goa.avif"
export { default as Jaipur } from "../assets/images/holiday/Jaipur.avif"
export { default as Mumbai } from "../assets/images/holiday/Mumbai.avif"
export { default as Amritsar } from "../assets/images/holiday/Amritsar.avif"
export { default as chennai } from "../assets/images/holiday/chennai.avif"
export { default as Shimla } from "../assets/images/holiday/Shimla.avif"
export { default as Hyderabad } from "../assets/images/holiday/Hyderabad.avif"
export { default as DubaiHotel } from "../assets/images/holiday/Dubai.avif"
export { default as singapore } from "../assets/images/holiday/singapore.avif"
export { default as Riyadh } from "../assets/images/holiday/Riyadh.avif"
export { default as muscat } from "../assets/images/holiday/muscat.avif"
export { default as kuala_lumpur } from "../assets/images/holiday/kuala-lumpur.avif"
export { default as bangkok } from "../assets/images/holiday/bangkok.avif"


export { default as Kerala } from "../assets/images/Packages/Kerala.webp"
export { default as Alleppey } from "../assets/images/Packages/Alleppey.jpg"
export { default as Bekal } from "../assets/images/Packages/Bekal.jpg"
export { default as Kannur } from "../assets/images/Packages/Kannur.jpg"
export { default as Thekkady } from "../assets/images/Packages/Thekkady.jpg"
export { default as Wayanad } from "../assets/images/Packages/Wayanad.jpg"
export { default as Cochin } from "../assets/images/Packages/Cochin.jpg"
export { default as Munnar } from "../assets/images/Packages/Munnar.jpg"
export { default as Kovalam } from "../assets/images/Packages/Kovalam.jpg"
export { default as Vagamon } from "../assets/images/Packages/Vagamon.jpg"


export { default as the } from "../assets/images/Featured/the.webp"
export { default as BusinessStandard } from "../assets/images/Featured/business-standard.webp"
export { default as DailyHunt } from "../assets/images/Featured/Dailyhunt.webp"
export { default as ani } from "../assets/images/Featured/ANI.webp"
export { default as ThePrint } from "../assets/images/Featured/theprint.webp"


export { default as iso } from "../assets/images/certificate/iso_9001-2015.webp"
export { default as iso_iec } from "../assets/images/certificate/iso-iec_27001-2022.webp"
export { default as IATA_Certificate_2025 } from "../assets/images/certificate/IATA-certificate-2025.jpg"


export const getAmenityImg = (amenity, fileExtension = 'png') => {
    // Sanitize the amenity string
    let amenityImg = amenity
    .replace(/[\[\(\{].*?[\]\)\}]/g, '')  // Remove bracketed content
    .replace(/[:]/g, '')                 // Remove colons
    .replace(/\//g, '-')
    .trim()
    .replace(/\s+/g, '-')                // Replace spaces with dashes
    .toLowerCase();
  
    // List of available amenity image filenames (without extensions)
    const hotelAmenities = ['heating', 'towels-provided', 'tv-size-26', 'tv', 'towels', 'non-smoking', 'shower-only', 'shower', 'soundproofed-rooms'
        ,'soundproofed','bathroom', 'free-toiletries', 'toiletries', 'magnifying-mirror', 'mirror','television',
        'dining-table', 'smoking-and-non-smoking', 'sleep-number-by-select-comfort-mattress', 'premium-bedding', 'blackout-drapes-curtains', 'blackout-drapes-curtains', 'drapes-curtains',
        'wardrobe-or-closet', 'daily-housekeeping', 'individually-decorated', 'free-wifi', 'individually-furnished', 'phone', 'desk', 'first-run-movies', 'hair-dryer', 'premium-tv-channels',
        'highchair', 'bedsheets-provided', 'soap', 'toilet-paper', 'shampoo', 'lever-door-handles', 'toothbrush-and-toothpaste-available-on-request', 'refrigerator', 'washer-dryer', 'private-bathroom',
        'air-conditioning', 'rollaway-extra-beds', 'fireplace', 'separate-sitting-area', 'room-service', 'cable-tv-service', 'free-bottled-water', 'breakfast', 'parking', 'sound-proofed-rooms', 'hair-dryer', 'smoking',
        'money-back', 'microwave', 'refrigerator', 'kitchen'
    ];
    if (hotelAmenities.includes(amenityImg)) {
      return `/images/amenities/${amenityImg}.${fileExtension}`;
    }
    // Try partial match: if the amenityImg contains any hotel amenity
    const partialMatch = hotelAmenities.find(h => amenityImg.includes(h));
    if (partialMatch) {
      return `/images/amenities/${partialMatch}.${fileExtension}`;
    }
    return `/images/amenities/default.webp`;
  };

  export const getTopAmenities = (amenities = [], start = 0, count = 3) => {
  const sortedAmenities = [
    { label: "Room service", image: "room-service.png" },
    { label: "Restaurant", image: "restaurant.png" },
    { label: "Swimming Pool", image: "swimming-pool.png" },
    { label: "Spa", image: "spa.png" }, // exact match
    { label: "Free bottled water", image: "free-bottled-water.png" },
    { label: "Hair dryer", image: "hair-dryer.png" },
    { label: "Daily housekeeping", image: "daily-housekeeping.png" },
    { label: "Soundproofed room", image: "sound-proofed-rooms.png" },
    { label: "Airport shuttle", image: "airport-shuttle.png" },
    { label: "Rollaway/extra beds", image: "rollaway-extra-beds.png" },
    { label: "cribs/infant beds", image: "cribs-infant-beds.png" },
    { label: "Luggage Assistance", image: "luggage-assistance.png" },
    { label: "Caretaker", image: "caretaker.png" },
    { label: "Laundry", image: "laundry.png" },
    { label: "Smoking", image: "smoking.png" }, // exact match
    { label: "Free WiFi", image: "free-wifi.png" },
    { label: "Microwave", image: "microwave.png" },
    { label: "Refrigerator", image: "refrigerator.png" },
    { label: "Kitchen", image: "kitchen.png" },
  ];

  const exactMatchLabels = ["Spa", "Smoking"];

  const prioritizedAmenities = [];

  for (const priorityItem of sortedAmenities) {
    const matchedAmenity = amenities.find(a => {
      if (exactMatchLabels.includes(priorityItem.label)) {
        return a.toLowerCase() === priorityItem.label.toLowerCase();
      }
      return a.toLowerCase().includes(priorityItem.label.toLowerCase());
    });

    if (matchedAmenity) {
      prioritizedAmenities.push({
        label: matchedAmenity,
        image: priorityItem.image
      });
    }
  }

  return prioritizedAmenities.slice(start, Math.min(start + count, 4));
};

export const formatCancellationPolicies = (rawText = '') => {
  const formatDate = (rawDateStr) => {
    if (!rawDateStr) return 'Invalid Date';
    const match = rawDateStr.match(/^(\d{2})-(\w{3})-(\d{4}) (\d{2}):(\d{2}):(\d{2})$/);
    if (!match) return 'Invalid Date';

    const [_, day, monStr, year, hour, minute, second] = match;
    const monthMap = {
      Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
      Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11,
    };
    const monthIndex = monthMap[monStr];
    if (monthIndex === undefined) return 'Invalid Date';

    const utcDate = new Date(Date.UTC(+year, monthIndex, +day, +hour, +minute, +second));
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(utcDate.getTime() + istOffset);

    return istDate.toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }) + ' (IST)';
  };

  return rawText
    .replace('|#!#', '')
    .replace('.|', '|')
    .split('|')
    .filter(Boolean)
    .map(policy => {
      const match = policy.match(/^(.*?) if cancelled between (.+?) and (.+?)$/i);
      if (match) {
        const [_, chargeText, fromDate, toDate] = match;

        const cleanedCharge = chargeText.trim();

        // Only include "No cancellation charge" policies
        if (/^No cancellation charge/i.test(cleanedCharge)) {
          return `No cancellation charge if cancelled between ${formatDate(fromDate)} and ${formatDate(toDate)} (inclusive).`;
        }
      }
      return null;
    })
    .filter(Boolean); // remove nulls
};

export const getCombinedAmenitiesToDisplay = (amenities = [], inclusion = [], getTopAmenities, maxCount = 3) => {
  const filteredInclusions = inclusion?.filter(item => item !== 'Room Only') || [];
  let totalInclusion = filteredInclusions.length;
  const topCount = Math.max(0, 4 - totalInclusion);

  const topAmenities = getTopAmenities(amenities, 4, 7);
  totalInclusion = topAmenities.length;

  const results = [...topAmenities];

  if (totalInclusion < maxCount) {
    const shownLabels = new Set(topAmenities.map(a => a.label.toLowerCase()));
    const extraAmenities = amenities
      .filter(a => !Array.from(shownLabels).some(label => a.toLowerCase().includes(label)))
      .slice(0, maxCount - totalInclusion);

    extraAmenities.forEach(extra => {
      results.push({ label: extra, image: extra }); // use raw name for label/image
    });
  }

  return results;
};



  

